<ul class="nav float-left" style="padding-left:20px">
    <a [routerLink]="['/']">
        <img *ngIf="appService.Data.company_log" src="{{appService.Data.company_log}}" class="company_logo_img"
            style="width: 100px;height: 31px;margin-top: 3px;" alt="">
    </a>
</ul>
<ul class="nav mob-perticular float-right">
    <li class="nav-item">
        <div class="nav-link" style="padding: 0.5rem 10px 0.5rem 10px !important;">
            <div class="theme-toggle-container" style="position: relative;top: -7px;">
                <a [routerLink]="['/notifications']">

                    <label class="theme-label">
                        <i class="fa fa-bell-o theme-icon" aria-hidden="true"></i>
                        <span *ngIf="appService.notification_count>0" class="badge badge-pill bg-primary float-right"
                            style="    color: #fff;
                            font-size: 50%;
                            font-weight: 100;">{{ (appService.notification_count < 99) ? appService.notification_count
                                : '99+' }}</span>
                    </label>
                </a>
            </div>
        </div>
    </li>
    <!-- <li class="nav-item" *ngIf="!appService.isSellerloginbtn">
        <a class="nav-link" style="color: #474747;padding: 0.5rem 10px 0.5rem 10px !important;display: flex;">
            <mat-icon class="material-icons">person_add</mat-icon>
            <span class="person-category main_person">{{appService.Data.user_details.user_name}} (<span routerLink="/"
                    style="color: #474747;">{{appService.Data.user_details.role_name}}</span>)</span>
        </a>
    </li> -->
    <!-- <li class="nav-item" *ngIf="!appService.isSellerloginbtn">
        <a class="nav-link"
            style="color: #474747;cursor: pointer;padding: 0.5rem 10px 0.5rem 10px !important;display: flex;"
            (click)="signout()">
            <mat-icon class="material-icons">logout</mat-icon>
            <span class="logout_text">Logout</span>
        </a>
    </li> -->
    <!-- <li class="nav-item" *ngIf="appService.isSellerloginbtn">
        <a class="nav-link"
            style="color: #474747;cursor: pointer;padding: 0.5rem 10px 0.5rem 10px !important;display: flex;"
            (click)="signout()">
            <mat-icon class="mat-icon-sm">person</mat-icon>
            <span>Login</span>
        </a>
    </li> -->
    <li class="nav-item">
        <div class="nav-link" style="padding: 0.5rem 10px 0.5rem 10px !important;">
            <div class="theme-toggle-container" style="position: relative;top: -7px;">
                <input id="theme-switch" class="theme-switch" type="checkbox" (change)="toggleBackground($event)">
                <label for="theme-switch" id="theme-label">
                    <i id="theme-icon" class="fa fa-moon-o theme-icon" aria-hidden="true"></i>
                </label>
            </div>
        </div>
    </li>
</ul>